import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { TagIcon } from '../../theme/Icons';
import { TagsField } from '../../tags/TagsField';
import { INote } from '../generic-notes/INote';

interface TagsSectionProps {
    note: INote;
}

export const TagsSection: FC<TagsSectionProps> = ({ note }) => {
    if (!note.tags || note.tags.length === 0) {
        return null;
    }

    return (
        <ViewNoteSection title="Tags" Icon={TagIcon}>
            <TagsField
                value={note.tags || []}
                onChange={() => {}} // No-op since this is view mode
                disabled={true}
                hideHeaderInViewMode={true}
            />
        </ViewNoteSection>
    );
};
